import React from 'react';
import { inputStyles } from '../../styles/common';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  fullWidth?: boolean;
}

const Input: React.FC<InputProps> = ({
  label,
  error,
  fullWidth = true,
  className = '',
  id,
  ...props
}) => {
  const widthStyles = fullWidth ? 'w-full' : '';

  return (
    <div className={`${widthStyles} ${className}`}>
      {label && (
        <label htmlFor={id} className="mb-2 block text-xs uppercase tracking-[0.18em] text-[color:var(--wf-brass)]">
          {label}
        </label>
      )}
      <input id={id} className={`${inputStyles.base} ${error ? inputStyles.error : ''}`} {...props} />
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default Input;
